import { render } from "./dynamicLoader.vue?vue&type=template&id=10ac6b79"
import script from "./dynamicLoader.vue?vue&type=script&lang=js"
export * from "./dynamicLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__